<template>
  <div>
    <SimpleLoader v-if="loading" />
    <table class="w-100" border="0" align="center">
      <tr>
        <td class="background-app padding-ios" colspan="4" align="center" width="100%" height="40">
          PRODUCCIÓN MENSUAL
        </td>
      </tr>
      <tr class="header" bgcolor="#CCCCCC">
        <td align="center" height="30">
          <strong>ID pago</strong>
        </td>
        <td align="center" width="100">
          <strong>Tipo</strong>
        </td>
        <td>
          <strong>Fecha</strong>
        </td>
        <td>
          <strong>Monto</strong>
        </td>
      </tr>
      <tr class="font-14" v-for="service in services" :key="service.id_pay" style="border-bottom: 1px solid #ccc">
        <td align="center" height="50" width="90">{{ service.id_pay }}</td>
        <td align="center" width="100">{{ service.type }}</td>
        <td align="center">{{ formatDate(service.date) }}</td>
        <td align="center">{{ formatPrice(service.value) }}</td>
      </tr>
    </table>
    <h2 class="total text-center mt-3">Total {{ formatPrice(total) }}</h2>
  </div>
</template>

<script>
import http from '../http'
import SimpleLoader from '../components/Loader.vue'

export default {
  name: 'ProductionMonth',
  components: {
    SimpleLoader
  },
  data() {
    return {
      services: [],
      total: 0,
      loading: true
    }
  },
  created() {
    this.loadProductionMonth()
  },
  methods: {
    loadProductionMonth() {
      this.loading = true
      http.get('app/service/finished/month')
        .then(res => {
          this.services = res.body.services
          this.total = this.services.reduce((sum, service) => sum + service.value, 0)
          this.loading = false
        })
        .catch(err => {
          console.error('Error loading production month:', err)
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return ''
      var dateParts = date.split('-')
      var year = dateParts[0]
      var month = dateParts[1]
      var day = dateParts[2]
      var localDate = new Date(year, month - 1, day)
      return localDate.toLocaleDateString('es-CL')
    },
    formatPrice(price) {
      if (!price) return '$0'
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
      }).format(price)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/ProductionMonth.vue